import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { useAuthStore } from "../../model/store/authStore";

export const isAuth = () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstance.get<string>(LIGIN_API_URL.isAuth(), {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};
